export default "__VITE_ASSET__CtjiTM$i__"